<span [ngbPopover]="locatorContent" triggers={{triggers}} [autoClose]="'outside'" placement="top" *ngIf="!pwLocator">{{locator?.name}}</span>
<span [ngbPopover]="locatorContent" triggers={{triggers}} [autoClose]="'outside'" placement="top" *ngIf="pwLocator">{{pwLocator?.name}}</span>
<ng-template #locatorContent>
  <table class="table table-condensed table-hover" *ngIf="!pwLocator">
    <tr class="active">
      <th>Type</th>
      <th *ngIf="by">By</th>
      <th>Path</th>
      <th>Use JQuery</th>
    </tr>
    <tr>
      <td>{{locator?.componentType}}</td>
      <td *ngIf="by">{{locator?.locatorType}}</td>
      <td class="xpath-content">{{locator?.locatorString}}</td>
      <td>{{locator?.useJquery}}</td>
    </tr>
  </table>
  <table class="table table-condensed table-hover" *ngIf="pwLocator">
    <tr class="active">
      <th>Name</th>
      <th *ngIf="by">By</th>
      <th>Path</th>
    </tr>
    <tr>
      <td>{{pwLocator?.name}}</td>
      <td *ngIf="by">{{pwLocator?.locatorType}}</td>
      <td class="xpath-content">{{pwLocator?.locatorString}}</td>
    </tr>
  </table>
</ng-template>